import { classNames } from 'primereact/utils'

export const TRANSITIONS = {
    overlay: {
        timeout: 150,
        classNames: {
            enter: 'opacity-0 scale-75',
            enterActive: 'opacity-100 !scale-100 transition-transform transition-opacity duration-150 ease-in',
            exit: 'opacity-100',
            exitActive: '!opacity-0 transition-opacity duration-150 ease-linear'
        }
    }
};

const tieredMenu = {
    root: () => {
        return {
            className: classNames('bg-white rounded-lg overflow-hidden w-[13.5rem] mt-2.5', 'shadow')
        }
    },
    menu: () => {
        return {
            className: classNames('outline-none', 'm-0 p-0 list-none')
        }
    },
    menuitem: () => 'relative',
    content: ({ context }) => {
        return {
            className: classNames(
                'transition-shadow duration-200 border-none rounded-none',
                'hover:bg-faded-blue hover:text-gray-700', //Hover
                {
                    'text-gray-700': !context.focused && !context.active,
                    'bg-gray-300 text-gray-700': context.focused && !context.active,
                    'bg-blue-100 text-blue-700': context.focused && context.active,
                    'bg-blue-50 text-blue-700': !context.focused && context.active
                }
            )
        }
    },
    action: ({ context }) => {
        return {
            className: classNames('py-3 px-5 select-none', 'flex items-center cursor-pointer no-underline relative overflow-hidden', {
                'text-gray-700 hover:text-gray-700 hover:bg-faded-blue': !context.active,
                'text-blue-600 bg-blue-100': context.active
            })
        }
    },
    icon: () => 'mr-2 text-allstate-blue',
    submenuicon: () => 'ml-auto',
    separator: () => 'border-t border-gray-300 my-1',
    submenu: () => {
        return {
            className: classNames('py-1 bg-white border-0 shadow-md min-w-full', 'absolute z-10', 'left-full top-0')
        }
    },
    transition: () => TRANSITIONS.overlay
}

export default tieredMenu